exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "time {\r\n    color: #fff !important;\r\n}\r\n\r\n.post-add-icon {\r\n    color: #fff !important;\r\n}\r\n\r\n.has-children {\r\n    background-color: #e7ebec !important;\r\n}\r\n\r\n.has-children .more {\r\n    margin-right: 10px;\r\n}\r\n\r\n.olymp-three-dots-icon {\r\n    fill: #fff;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/reply-item/reply-item.component.css
// module id = ../../../../../src/app/post-item/reply-item/reply-item.component.css
// module chunks = main